import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { wabaApi } from "../../lib/wabaApi";

const MAX = 280;

/**
 * Texto da resposta pública a comentários no Instagram.
 *
 * É template FIXO de propósito: o comentário fica no perfil do cliente para
 * sempre, então a IA não escreve aqui. Vazio = a conexão só registra
 * comentários, sem responder nada em público.
 */
export function IgCommentReply({ conn, onChanged }: { conn: any; onChanged: () => void | Promise<void> }) {
  const qc = useQueryClient();
  const [text, setText] = useState<string>(conn.ig_comment_reply ?? "");
  const [saving, setSaving] = useState(false);

  const dirty = text.trim() !== (conn.ig_comment_reply ?? "").trim();

  async function save() {
    setSaving(true);
    try {
      await wabaApi.patch(`/connections/${conn.id}`, { ig_comment_reply: text.trim() });
      qc.invalidateQueries({ queryKey: ["waba-connections"] });
      await onChanged();
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      <textarea
        value={text}
        onChange={e => setText(e.target.value.slice(0, MAX))}
        rows={2}
        placeholder="Ex.: Te chamei no direct! 📩"
        style={{
          padding: "6px 8px", background: "var(--surface-raised)",
          border: "1px solid var(--line-strong)", borderRadius: 6,
          color: "var(--ink)", fontSize: 12, outline: "none", resize: "vertical",
          fontFamily: "inherit",
        }}
      />
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: 11, color: "var(--ink-muted)", flex: 1 }}>
          {text.trim()
            ? "Publicado no post e seguido de um direct para o autor do comentário."
            : "Vazio: comentários são registrados, mas não recebem resposta."}
        </span>
        <span style={{ fontSize: 11, color: "var(--ink-muted)" }}>{text.length}/{MAX}</span>
        <button
          onClick={save}
          disabled={saving || !dirty}
          style={{
            padding: "5px 12px", borderRadius: 6, border: "1px solid var(--line-strong)",
            background: dirty ? "var(--surface-raised)" : "var(--surface-input)",
            color: dirty ? "var(--ink)" : "var(--ink-muted)",
            fontSize: 12, cursor: saving || !dirty ? "default" : "pointer",
          }}
        >
          {saving ? "Salvando..." : "Salvar"}
        </button>
      </div>
    </div>
  );
}
